import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import React from 'react';

export interface UnsavedChangesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDiscard: () => void;
}

const UnsavedChangesModal = ({
  isOpen,
  onClose,
  onDiscard,
}: UnsavedChangesModalProps) => (
  <Dialog fullWidth maxWidth="sm" open={isOpen} onClose={onClose}>
    <DialogTitle>Unsaved Changes</DialogTitle>
    <IconButton aria-label="close" onClick={onClose} sx={closeIconStyle}>
      <CloseIcon />
    </IconButton>
    <DialogContent>
      <Typography>
        You have unsaved changes. Are you sure you want to close without saving?
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button variant="outlined" color="error" onClick={onDiscard}>
        Discard Changes
      </Button>
      <Button variant="contained" color="primary" onClick={onClose}>
        Cancel
      </Button>
    </DialogActions>
  </Dialog>
);

const closeIconStyle = (theme: Theme) => ({
  position: 'absolute',
  right: 8,
  top: 8,
  color: theme.palette.grey[500],
});

export default UnsavedChangesModal;
